/* eslint-disable max-len */
import React from "react";
import { Helmet } from "react-helmet";
import { isClientSideRendering } from "../../../helpers/rendererType";

export const Infogram = () => {
  if (!isClientSideRendering()) {
    return null;
  }
  return (
    <>
      <div
        className="infogram-embed"
        data-id="43cc5233-b105-4651-9890-a5884899ddbf"
        data-type="interactive"
        data-title="Rate watch: 2-year fixed rate comparison"
      />
      <Helmet>
        <script type="text/javascript">
          {` 
!function(e,n,i,s){var d="InfogramEmbeds";var o=e.getElementsByTagName(n)[0];if(window[d]&&window[d].initialized)window[d].process&&window[d].process();else if(!e.getElementById(i)){var r=e.createElement(n);r.async=1,r.id=i,r.src=s,o.parentNode.insertBefore(r,o)}}(document,"script","infogram-async","https://e.infogram.com/js/dist/embed-loader-min.js");
`}
        </script>
      </Helmet>
    </>
  );
};
